// Hero/Home Section Data
import { SectionHeader } from './schemas';
import { sharedData } from './sharedData';

export const heroData = {
  header: new SectionHeader("Hello, I'm", sharedData.personal.name, "home"),
  
  image: sharedData.personal.image,
  
  content: {
    greeting: "Hello, I'm",
    name: sharedData.personal.name,
    title: "Software Engineer & Program Coordinator",
    introTagline: "Serial Achiever • Entrepreneur",
    subtitle: "Building innovative mobile solutions and leading tech initiatives",
    description: "Passionate about creating technology that makes a difference.",
    philosophy: "I believe in continuous learning, collaborative problem-solving, and creating technology that makes a positive impact on people's lives.",
    cta: {
      primary: {
        text: "Get In Touch",
        href: "#contact",
        className: "btn btn-primary"
      },
      secondary: {
        text: "View My Work",
        href: "#portfolio",
        className: "btn btn-secondary"
      }
    }
  },
  
  socialLinks: sharedData.socialLinks
};
